import { render, staticRenderFns } from "./PagamentoDetalheReprovacao.vue?vue&type=template&id=4d19a272"
import script from "./PagamentoDetalheReprovacao.vue?vue&type=script&lang=js"
export * from "./PagamentoDetalheReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports